/* ── "Alla skriver om studentmössorna" (sections/bac-press.liquid) ──────────────────────────────────────────────────────────────
   Två rader med rubriker glider åt var sitt håll i jämn takt (transform, en bildruta i taget). Fingret/musen kan dra i raden —
   den följer 1:1, fortsätter med kastets fart och lugnar sig tillbaka till sin egen takt. Ett tryck utan drag öppnar urklippet:
   papperet växer fram ur kortet (uniform skala, ingen förvrängning) och visar citatet med länken till artikeln.
   Pausar när sektionen är utanför skärmen, fliken dold, musen vilar över raden eller ett urklipp är öppet.
   Utan JS är korten vanliga länkar till artiklarna; med reducerad rörelse blir raderna vanlig sidscroll. */
(() => {
  "use strict";
  const sek = document.getElementById("baccap-press"); if (!sek) return;
  const lugn = matchMedia("(prefers-reduced-motion: reduce)");
  const rader = [...sek.querySelectorAll(".p__rad")];
  const lager = sek.querySelector(".p__lager"), blad = sek.querySelector(".p__blad"), stang = sek.querySelector(".p__stang");
  const bKalla = sek.querySelector(".p__bkalla"), bRubrik = sek.querySelector(".p__brubrik"), bCitat = sek.querySelector(".p__bcitat"), bDatum = sek.querySelector(".p__bdatum"), bLank = sek.querySelector(".p__blank");
  const E = "cubic-bezier(.22,.61,.12,1)";
  let oppet = null, synlig = true, spar = [];

  /* ── urklippet ── */
  function fyll(kort) {
    const d = kort.dataset;
    bKalla.textContent = "";
    if (d.logo) {   /* utgivarens logga på papperet: ljus variant om den finns, annars samma logga svart */
      const s = document.createElement("span"), im = document.createElement("img");
      s.className = "p__blogo" + (d.egen === "true" ? " is-egen" : "");
      im.src = d.logoLjus || d.logo; im.alt = d.kalla || ""; im.decoding = "async"; if (d.lh) im.style.setProperty("--lh", d.lh + "px");
      s.appendChild(im); bKalla.appendChild(s);
    } else bKalla.append(d.kalla || "");
    if (d.av) { const s = document.createElement("span"); s.className = "p__bav"; s.textContent = (d.logo ? "" : "· ") + d.av; bKalla.appendChild(s); }
    bRubrik.textContent = d.rubrik || kort.querySelector(".p__rubrik").textContent;
    bCitat.textContent = d.citat ? "”" + d.citat + "”" : ""; bCitat.hidden = !d.citat;
    bDatum.textContent = d.datum || ""; bDatum.hidden = !d.datum;
    bLank.href = kort.href; bLank.querySelector("span").textContent = "Läs hos " + (d.lank || d.kalla || "källan");
  }
  function oppna(kort) {
    if (oppet) return;
    oppet = kort; fyll(kort);
    lager.hidden = false; kort.classList.add("is-oppen");
    const a = kort.getBoundingClientRect(), b = blad.getBoundingClientRect();
    const s = Math.min(1, a.width / b.width), dx = a.left + a.width / 2 - (b.left + b.width / 2), dy = a.top + a.height / 2 - (b.top + b.height / 2);
    requestAnimationFrame(() => lager.classList.add("is-on"));
    if (!lugn.matches) {
      blad.animate([{ transform: `translate(${dx}px,${dy}px) scale(${s})`, opacity: .4 }, { transform: "none", opacity: 1 }], { duration: 480, easing: E, fill: "both" });
      [...blad.children].forEach((el, i) => el.animate([{ opacity: 0 }, { opacity: 0, offset: .3 }, { opacity: 1 }], { duration: 480 + i * 30, easing: "ease-out" }));
    }
    setTimeout(() => stang.focus({ preventScroll: true }), 60);
  }
  function stangUrklipp() {
    if (!oppet) return;
    const kort = oppet; oppet = null;
    lager.classList.remove("is-on");
    const klar = () => { lager.hidden = true; kort.classList.remove("is-oppen"); if (kort.isConnected) kort.focus({ preventScroll: true }); };
    if (lugn.matches) { klar(); return; }
    const a = kort.getBoundingClientRect(), b = blad.getBoundingClientRect();
    const s = Math.min(1, a.width / b.width), dx = a.left + a.width / 2 - (b.left + b.width / 2), dy = a.top + a.height / 2 - (b.top + b.height / 2);
    const an = blad.animate([{ transform: "none", opacity: 1 }, { transform: `translate(${dx}px,${dy}px) scale(${s})`, opacity: 0 }], { duration: 300, easing: E, fill: "both" });
    an.onfinish = () => { an.cancel(); klar(); };
  }
  stang.addEventListener("click", stangUrklipp);
  lager.addEventListener("click", e => { if (e.target === lager) stangUrklipp(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && oppet) { e.preventDefault(); stangUrklipp(); } });

  /* ── raderna ── */
  const still = lugn.matches || !("ResizeObserver" in window);
  sek.classList.toggle("is-still", still);
  rader.forEach((rad, ri) => {
    const sp = rad.querySelector(".p__spar"), orig = [...sp.children];
    const rikt = +rad.dataset.rikt || (ri ? 1 : -1), fart = +rad.dataset.fart || (ri ? 22 : 27);
    const st = { x: 0, W: 0, v: 0, drag: null, mus: false, fokus: false, drog: false };
    orig.forEach(k => k.addEventListener("click", e => { if (st.drog) { e.preventDefault(); return; } e.preventDefault(); oppna(k); }));
    if (still) return;
    /* kopian gör slingan sömlös; den är osynlig för hjälpmedel och tangentbord */
    orig.forEach(k => { const c = k.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.tabIndex = -1; c.classList.add("is-kopia");
      c.addEventListener("click", e => { e.preventDefault(); if (!st.drog) oppna(k); }); sp.appendChild(c); });
    const gap = () => parseFloat(getComputedStyle(sp).columnGap || getComputedStyle(sp).gap) || 10;
    const matt = () => { st.W = orig.reduce((s, k) => s + k.offsetWidth, 0) + gap() * orig.length; if (!st.W) return; if (!st.klar) { st.x = -st.W * (ri ? .38 : .06); st.klar = true; } vik(); };
    const vik = () => { if (!st.W) return; while (st.x <= -st.W) st.x += st.W; while (st.x > 0) st.x -= st.W; };
    const rita = () => { sp.style.transform = `translate3d(${st.x.toFixed(2)}px,0,0)`; };
    new ResizeObserver(matt).observe(sp); matt();
    /* drag: pekaren äger raden, sidan får fortfarande scrolla lodrätt (touch-action: pan-y) */
    rad.addEventListener("pointerdown", e => {
      if (e.button && e.button !== 0) return;
      st.drag = { id: e.pointerId, x0: e.clientX, px: e.clientX, pt: performance.now(), sx: st.x, v: 0 }; st.drog = false;
      rad.classList.add("is-drar");
    });
    rad.addEventListener("pointermove", e => {
      const d = st.drag; if (!d || e.pointerId !== d.id) return;
      const dx = e.clientX - d.x0;
      if (!st.drog && Math.abs(dx) > 6) { st.drog = true; try { rad.setPointerCapture(d.id); } catch (_) {} }
      if (!st.drog) return;
      const nu = performance.now(), dt = Math.max(1, nu - d.pt);
      d.v = d.v * .5 + ((e.clientX - d.px) / dt * 1000) * .5; d.px = e.clientX; d.pt = nu;
      st.x = d.sx + dx; vik(); rita();
    });
    const slapp = e => {
      const d = st.drag; if (!d || (e && e.pointerId !== d.id)) return;
      st.drag = null; rad.classList.remove("is-drar");
      if (st.drog) { st.v = Math.max(-2600, Math.min(2600, performance.now() - d.pt > 80 ? 0 : d.v)); setTimeout(() => { st.drog = false; }, 0); }
    };
    rad.addEventListener("pointerup", slapp); rad.addEventListener("pointercancel", slapp); rad.addEventListener("lostpointercapture", slapp);
    rad.addEventListener("pointerenter", e => { if (e.pointerType === "mouse") st.mus = true; });
    rad.addEventListener("pointerleave", e => { if (e.pointerType === "mouse") st.mus = false; });
    rad.addEventListener("focusin", () => { st.fokus = true; }); rad.addEventListener("focusout", () => { st.fokus = false; });
    spar.push({ st, rikt, fart, rita, vik });
  });

  /* ── klockan: en bildruta i taget, alla rader i samma takt ── */
  if (!still && spar.length) {
    let fore = 0;
    const steg = nu => {
      const dt = Math.min(.05, fore ? (nu - fore) / 1000 : 0); fore = nu;
      const paus = !synlig || document.hidden || !!oppet;
      for (const r of spar) {
        const s = r.st; if (s.drag && s.drog) continue;
        const mal = paus || s.mus || s.fokus ? 0 : r.rikt * r.fart;
        s.v += (mal - s.v) * (1 - Math.exp(-dt * (Math.abs(s.v) > Math.abs(mal) + 40 ? 2.2 : 3.4)));   /* kastet dör ut lite långsammare än starten */
        if (Math.abs(s.v - mal) < .4) s.v = mal;
        if (s.v) { s.x += s.v * dt; r.vik(); r.rita(); }
      }
      requestAnimationFrame(steg);
    };
    requestAnimationFrame(steg);
    if ("IntersectionObserver" in window) new IntersectionObserver(es => { synlig = es.some(e => e.isIntersecting); }, { rootMargin: "80px 0px" }).observe(sek);
  }
})();
